import { render, staticRenderFns } from "./assessment-controller.vue?vue&type=template&id=2170e9f6&"
import script from "./assessment-controller.vue?vue&type=script&lang=ts&"
export * from "./assessment-controller.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports